import { render, staticRenderFns } from "./resetpwd.vue?vue&type=template&id=0949eefa&scoped=true"
import script from "./resetpwd.vue?vue&type=script&lang=js"
export * from "./resetpwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0949eefa",
  null
  
)

export default component.exports